import { render, staticRenderFns } from "./asistenciaRemota.vue?vue&type=template&id=d882dcc8&"
import script from "./asistenciaRemota.vue?vue&type=script&lang=js&"
export * from "./asistenciaRemota.vue?vue&type=script&lang=js&"
import style0 from "./asistenciaRemota.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports